var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1473_663)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1473_663)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.4552 18.9277L7.76075 19.1087C9.04406 19.8703 10.5155 20.2732 12.016 20.2739H12.0192C16.6273 20.2739 20.3776 16.5245 20.3795 11.916C20.3803 9.68285 19.5115 7.58283 17.9331 6.00312C17.1589 5.22406 16.2378 4.60629 15.2233 4.18558C14.2087 3.76487 13.1208 3.54958 12.0225 3.55216C7.41076 3.55216 3.66035 7.3012 3.65871 11.9093C3.65644 13.4829 4.09956 15.0249 4.93683 16.3573L5.13574 16.6733L4.291 19.7573L7.4552 18.9277ZM1.87585 22.1464L3.30299 16.9358C2.42284 15.4109 1.9598 13.681 1.96034 11.9087C1.96267 6.36418 6.4747 1.85352 12.0193 1.85352C14.7099 1.85488 17.2354 2.90196 19.1347 4.80266C21.0341 6.70336 22.0791 9.22979 22.0782 11.9167C22.0757 17.4608 17.563 21.9723 12.0192 21.9723H12.0148C10.3315 21.9716 8.6774 21.5493 7.20816 20.7482L1.87585 22.1464Z",
    fill: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.77258 22.043L3.19972 16.8324C2.31805 15.3039 1.85494 13.5699 1.85707 11.8053C1.85939 6.26078 6.37143 1.75012 11.916 1.75012C14.6067 1.75149 17.1321 2.79856 19.0315 4.69927C20.9308 6.59997 21.9758 9.1264 21.9749 11.8133C21.9724 17.3574 17.4597 21.8689 11.9159 21.8689H11.9115C10.2282 21.8682 8.57413 21.4459 7.10489 20.6448L1.77258 22.043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9191 3.44888C7.30736 3.44888 3.55695 7.19792 3.55531 11.8061C3.55304 13.3796 3.99615 14.9217 4.83342 16.254L5.03234 16.5702L4.1876 19.6541L7.35193 18.8244L7.65748 19.0054C8.94079 19.767 10.4122 20.1698 11.9128 20.1706H11.9159C16.524 20.1706 20.2745 16.4212 20.2762 11.8128C20.2797 10.7144 20.0653 9.62618 19.6453 8.61122C19.2254 7.59626 18.6083 6.67468 17.8298 5.89984C17.0556 5.12076 16.1345 4.50298 15.1199 4.08227C14.1054 3.66156 13.0174 3.44628 11.9191 3.44888V3.44888Z",
    fill: "url(#paint0_linear_1473_663)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.40194 7.60157C9.21355 7.1831 9.01532 7.17462 8.83636 7.16738L8.35459 7.1615C8.18698 7.1615 7.91465 7.22439 7.68443 7.47594C7.4542 7.72748 6.80469 8.33544 6.80469 9.572C6.80469 10.8086 7.70534 12.0034 7.83085 12.1713C7.95635 12.3392 9.56954 14.9576 12.1243 15.965C14.2473 16.8023 14.6793 16.6357 15.1403 16.5939C15.6013 16.5521 16.6273 15.986 16.8366 15.3991C17.0459 14.8122 17.046 14.3093 16.9833 14.2042C16.9205 14.0991 16.7529 14.0366 16.5014 13.9108C16.2498 13.785 15.0144 13.1771 14.784 13.0931C14.5536 13.0092 14.3862 12.9675 14.2184 13.2191C14.0507 13.4706 13.5696 14.0365 13.4229 14.2042C13.2762 14.3719 13.1298 14.393 12.8782 14.2674C12.6267 14.1417 11.8174 13.8762 10.8571 13.02C10.11 12.3538 9.60564 11.5311 9.45881 11.2797C9.31198 11.0283 9.44322 10.8921 9.56927 10.7669C9.68206 10.6542 9.82055 10.4733 9.94646 10.3266C10.0724 10.18 10.1138 10.0751 10.1975 9.90762C10.2811 9.74015 10.2394 9.59305 10.1765 9.46741C10.1137 9.34178 9.62532 8.09879 9.40194 7.60171",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1473_663",
    x: -1.12415,
    y: -1.14648,
    width: 26.2023,
    height: 26.293,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur_1473_663"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1473_663",
    x1: 11.7456,
    y1: 4.45234,
    x2: 11.8303,
    y2: 18.7421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#57D163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#23B33A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1473_663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.9541,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWhatsapp);
export default __webpack_public_path__ + "static/media/ic-whatsapp.b28ab6efa85124a35a1f3261c746c7ff.svg";
export { ForwardRef as ReactComponent };